import styled from 'styled-components';

// Common Container - используется в FirstScreen и SignUp
export const ByocOnboardingContainer = styled.div`
  // max-width: 700px;
  width: 70%;
  padding: 32px 32px 64px 32px;
  background-color: #ffffff;
  border-radius: 10px;
  margin-top: 29px;
  @media (max-width: 970px) {
    width: 100%;
  }
  .FirstScreenImg {
    width: 100%;
  }
`;

// Common Progress Bar
export const ByocOnboardingProgressBar = styled.img`
  max-width: 700px;
  margin-top: 29px;
  width: 100%;
`;

// Common Title - используется в FirstScreen и SignUp
export const ByocOnboardingTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 28px;
  color: #2f3d48;

  &.mTop28 {
    margin-top: 28px;
  }
`;

// Common Subtitle
export const ByocOnboardingSubtitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 17px;
  color: #2f3d48;

  &.mTop32 {
    margin-top: 32px;
  }
  span {
    color: #ff2d38;
  }
`;

// Common Text
export const ByocOnboardingText = styled.div`
  font-size: 14px;
  color: #2f3d48;

  &.bold {
    font-weight: 700;
  }
  &.mTop10 {
    margin-top: 10px;
  }
  &.mTop16 {
    margin-top: 16px;
  }
  &.mTop20 {
    margin-top: 20px;
  }
  &.mTop35 {
    margin-top: 35px;
  }
  &.mBottom27 {
    margin-bottom: 27px;
  }
  span {
    color: #ff2d38;
  }
  .gray {
    color: #929cb9;
  }
  .bold {
    font-weight: 700;
    color: #2f3d48;
  }
`;

// Common Error Container
export const ByocOnboardingError = styled.div`
  position: relative;
  .SignUpError {
    top: 5px;
    left: 0;
  }
`;

// Common Button Container
export const ByocOnboardingButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`;

// Common Loading Overlay
export const ByocOnboardingLoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.4);
  z-index: 10;
  border-radius: 10px;
`;
